import classNames from 'classnames';
import React from 'react';
import type { HtmlString } from '~/Features/Types/HtmlString.csharp';
import { HtmlHeading } from '~/Partials/Controls/HtmlHeading';
import styles from './PageSectionHeading.module.css';

interface PageSectionHeadingProps {
    heading: HtmlString;
    className?: string;
}

export const PageSectionHeading: React.FC<PageSectionHeadingProps> = props => {
    const { heading, className } = props;

    return <HtmlHeading type="h2" className={classNames(styles.PageSectionHeading, className)} html={heading} />;
};
